import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const mobileRoutingRoutes = {
  [ERouteMappingKeys.MOBILE_ROUTING]: {
    id: "mobile-routing",
    path: "/integrations/mobile-routing",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/Integrations/MobileRouting").then((p) => ({
          default: p.MobileRouting,
        })),
      ),
    },
  },
};
